// extracted by mini-css-extract-plugin
export var container = "layouts-components-__LanguageSelector-module___container";
export var option = "layouts-components-__LanguageSelector-module___option";
export var options = "layouts-components-__LanguageSelector-module___options";